import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import LandingPageLayout from '../../components/LandingPageLayout';
import styles from './Intercom.module.css';

const IntercomLanding = () => {
	const navigate = useNavigate();

	useEffect(() => {
		document.title = 'Intercom - GSD Support Admin';
		return () => {
			document.title = 'GSD Support Admin';
		};
	}, []);

	const featureCards = [
		{
			id: 'tickets',
			icon: <ConfirmationNumberIcon style={{ color: '#126e6f', fontSize: '2.5rem' }} />,
			title: 'Tickets',
			description: 'View and manage Intercom tickets.',
			buttonText: 'Go to Tickets',
		},
		{
			id: 'conversations',
			icon: <ForumOutlinedIcon style={{ color: '#126e6f', fontSize: '2.5rem' }} />,
			title: 'Conversations',
			description: 'Review Intercom conversations and replies.',
			buttonText: 'Go to Conversations',
		},
	];

	const handleFeatureClick = (featureId) => {
		navigate(`/intercom/${featureId}`);
	};

	return (
		<div className={styles.divStyle}>
				<LandingPageLayout
					title="Intercom"
					description="Choose an option to continue."
					features={featureCards}
					onFeatureClick={handleFeatureClick}
					onBackClick={() => navigate('/')}
					backButtonTooltip="Home page"
				>
					<div className={styles.betaNotice}>
						<h2 className={styles.betaTitle}>Beta feature</h2>
						<p className={styles.betaText}>
							The Intercom tools are in beta and still under active development.
						</p>
						<p className={styles.betaText}>
							Ticket search by account ID will be added in a future update.
						</p>
						<p className={styles.betaText}>
							Requests or suggestions? Reach out in Slack: #team-maia.
						</p>
					</div>
				</LandingPageLayout>
		</div>
	);
};

export default IntercomLanding;
